import { SessionPreference } from '@sondermind/utilities/models-session';

import { MatchingProfileReason } from './matching-profile-reason';

export class MatchingProfile {
  id: number | undefined;
  notes: string = '';
  locationName: string = '';
  lat: number | undefined;
  lng: number | undefined;
  distancePreference: number | undefined;
  sessionPreference: SessionPreference | undefined;
  intent: string = '';
  reasons: MatchingProfileReason[] = [];
  openPreferences: string | undefined;
  therapistGenderId: number;

  load_from_json(json: any): MatchingProfile {
    this.id = json.id;
    this.notes = json.notes;
    this.locationName = json.location_name;
    this.lat = json.lat;
    this.lng = json.lng;
    this.distancePreference = json.distance_preference;
    this.sessionPreference = json.session_preference;
    this.intent = json.intent;
    this.openPreferences = json.open_preferences;
    this.therapistGenderId = json.therapist_gender_id;

    this.reasons = (json.reasons || []).map((json_obj: any) => {
      const reason = new MatchingProfileReason();
      reason.load_from_json(json_obj);
      return reason;
    });

    return this;
  }
}
